import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import { withSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import {
  BLACKLIST_AUTHOR,
  BLACKLIST_POST,
} from '../../../helpers/graphql/blacklist';
import graphQLClient from '../../../helpers/graphQLClient';
import { getRoles } from '../../../helpers/token';

const BlacklistMenu = props => {
  const { open, onConfirm, onCancel, author, permlink, isComment } = props;
  const [state, setState] = useState({
    isShadowBlacklist: true,
    isOnlyCommentBlacklisted: false,
  });
  const [customReason, setCustomReason] = useState('');
  const [reason, setReason] = useState('');
  const [roles, setRoles] = useState(undefined);

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      props.enqueueSnackbar(notification.message, { variant });
    }
  };

  const handleBlacklistPost = () => {
    graphQLClient(BLACKLIST_POST, {
      author,
      permlink,
      reason: reason || customReason,
      isShadow: state.isShadowBlacklist,
      isComment,
    }).then(({ blacklistPost }) => {
      newNotification(blacklistPost);
      onConfirm();
    });
  };

  const handleBlacklistAuthor = () => {
    graphQLClient(BLACKLIST_AUTHOR, {
      author,
      permlink,
      reason: reason || customReason,
      isOnlyCommentBlacklisted: state.isOnlyCommentBlacklisted,
    }).then(({ blacklistAuthor }) => {
      newNotification(blacklistAuthor);
      onConfirm();
    });
  };

  const handleCheckboxChange = name => event => {
    setState({ [name]: event.target.checked });
  };

  const handleTextFieldChange = content => {
    setCustomReason(content.target.value);
  };

  const handleDropdownChange = event => {
    if (event.target.value === 'copyright' || event.target.value === 'spam')
      setState({ isShadowBlacklist: false });
    setReason(event.target.value);
  };

  useEffect(() => {
    if (props.isComment) {
      setState({ isShadowBlacklist: false });
      setState({ isOnlyCommentBlacklisted: true });
    }
    setRoles(getRoles());
  }, []);

  const isTeam = roles && roles.indexOf('team') !== -1;

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={onCancel}
      >
        <DialogTitle id="alert-dialog-title">
          Blacklist{' '}
          {permlink ? `Post @${author}/${permlink}` : `Author @${author}`}
        </DialogTitle>
        <DialogContent>
          {!customReason && (
            <>
              <DialogContentText>
                Choose a reason why you want to blacklist:
              </DialogContentText>
              <Select
                variant="standard"
                value={reason}
                onChange={handleDropdownChange}
              >
                <MenuItem value="short">Below 250 words</MenuItem>
                <MenuItem value="nottravel">Not travel-related</MenuItem>
                <MenuItem value="language">Not in English</MenuItem>
                <MenuItem value="copyright">Violating Copyright</MenuItem>
                <MenuItem value="spam">Spam</MenuItem>
              </Select>
            </>
          )}
          {!reason && (
            <>
              <DialogContentText>Or enter a custom reason</DialogContentText>
              <TextField
                variant="standard"
                autoFocus
                margin="dense"
                value={customReason}
                onChange={handleTextFieldChange}
                label="Reason"
                fullWidth
              />
            </>
          )}
          <DialogContentText>Options</DialogContentText>
          {!props.isComment && permlink && (
            <FormControlLabel
              labelPlacement="end"
              control={
                <Switch
                  checked={state.isShadowBlacklist}
                  onChange={handleCheckboxChange('isShadowBlacklist')}
                  color="primary"
                />
              }
              label="Shadow blacklist (only applies when blacklisting post)"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary">
            Cancel
          </Button>
          {permlink && (
            <Button
              variant="contained"
              onClick={handleBlacklistPost}
              color="primary"
            >
              Blacklist post
            </Button>
          )}
          {isTeam && (
            <Button
              onClick={handleBlacklistAuthor}
              color="primary"
              variant={permlink ? undefined : 'contained'}
            >
              Blacklist author
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withSnackbar(BlacklistMenu);
